import React from 'react';

import styles from './InstallmentsCalculatorCard.css';

interface Props {
  children: React.ReactNode;
  input: React.ReactNode;
}

export const InstallmentsCalculatorCard = ({ children, input }: Props) => (
  <div className={styles.InstallmentsCalculatorCard}>
    {input}
    {children}
  </div>
);
